/**
 * AlchamisMark — Renders the OFFICIAL Alchamis brand asset (/alchamis-logo.svg).
 *
 * The brand asset is a triangular gold mark with the "ALCHAMISGROUP" wordmark
 * integrated at its base. This component is the single source of truth used in
 * cards, section ornaments, the concierge widget, the 404 page, and any
 * decorative brand surface.
 *
 * Props:
 *  - size       — square px dimension (defaults to 40)
 *  - color      — accepted for API compatibility (ignored — the asset is fixed)
 *  - animated   — accepted for API compatibility (no-op on a raster)
 *  - strokeWidth — accepted for API compatibility (ignored)
 *  - filled     — accepted for API compatibility (ignored)
 *  - title      — accessible name (defaults to "Alchamis Group")
 */
// eslint-disable-next-line no-unused-vars
export function AlchamisMark({ size = 40, color, animated, strokeWidth, filled, title = "Alchamis Group", className = "" }) {
  return (
    <img
      src="/alchamis-logo.svg"
      alt={title}
      width={size}
      height={size}
      draggable="false"
      decoding="async"
      loading="lazy"
      className={`inline-block select-none object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
}

export default AlchamisMark;
